import {
  shape,
  string,
  arrayOf,
  number,
} from 'prop-types';

export const logType = shape({
  id: number.isRequired,
  action: string.isRequired,
  message: string.isRequired,
});

export const logsType = arrayOf(logType);


// WEBPACK FOOTER //
// ./src/prop-types/logTypes.js